import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "counter" ]

  connect() {
    setTimeout(this.update.bind(this))
  }

  update() {
    const root = this.element

    const countable = root.querySelectorAll(
      'input[type="checkbox"][data-countable]:checked, input[type="checkbox"][data-countable]:indeterminate'
    )

    const count = countable.length

    const counterEl =
      this.counterTarget ||
      root.querySelector(".accordion-counter")

    if (!counterEl) return

    counterEl.textContent = count

    if (count < 1) {
      counterEl.classList.add("tw:hidden")
    } else {
      counterEl.classList.remove("tw:hidden")
    }
  }
}
